<template>
  <b-modal
    v-model="visible"
    size="xl"
    centered
    hide-footer
    :title="title"
    @hidden="reset"
  >
    <b-alert v-if="unsupported" variant="warning" show class="p-1">
      {{ $t("axis_body_cam.recordings.unsupported_format") }}
    </b-alert>
    <b-alert v-if="failed" variant="danger" show class="p-1">
      {{ $t("axis_body_cam.recordings.part_error") }}
    </b-alert>

    <video
      v-if="current"
      ref="video"
      :key="current.id"
      class="w-100 bg-dark"
      style="max-height: 65vh"
      controls
      autoplay
      playsinline
      :src="current.stream_url"
      @ended="next"
      @error="failed = true"
      @playing="failed = false"
    />

    <b-list-group v-if="parts.length > 1" class="mt-1">
      <b-list-group-item
        v-for="(part, index) in parts"
        :key="part.id"
        button
        :active="index === currentIndex"
        class="d-flex align-items-center justify-content-between py-50"
        @click="select(index)"
      >
        <span>
          <feather-icon :icon="index === currentIndex ? 'PlayIcon' : 'FilmIcon'" size="14" class="mr-50" />
          {{ $t("axis_body_cam.recordings.part") }} {{ index + 1 }} / {{ parts.length }} · {{ part.object_name }}
        </span>
        <small>{{ formatBytes(part.bytes) }}</small>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import { BModal, BAlert, BListGroup, BListGroupItem } from "bootstrap-vue";

export default {
  components: { BModal, BAlert, BListGroup, BListGroupItem },
  data() {
    return {
      visible: false,
      title: "",
      parts: [],
      currentIndex: 0,
      unsupported: false,
      failed: false,
    };
  },
  computed: {
    current() {
      return this.parts[this.currentIndex] || null;
    },
  },
  methods: {
    open(recording, parts) {
      this.title = recording.container_name;
      this.parts = parts;
      this.currentIndex = 0;
      this.failed = false;
      this.unsupported = !document.createElement("video").canPlayType("video/x-matroska");
      this.visible = true;
    },
    select(index) {
      this.failed = false;
      this.currentIndex = index;
    },
    // The parts of one recording are played back to back, in order.
    next() {
      if (this.currentIndex < this.parts.length - 1) {
        this.select(this.currentIndex + 1);
      }
    },
    reset() {
      this.parts = [];
      this.currentIndex = 0;
    },
    formatBytes(bytes) {
      if (!bytes) return "-";
      const units = ["B", "KB", "MB", "GB"];
      const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
      return `${(bytes / 1024 ** index).toFixed(index ? 1 : 0)} ${units[index]}`;
    },
  },
};
</script>
